import * as React from 'react';

import TitleHeader from 'components/TitleHeader';

import './styles/ValuePropsRow.scss';

type Proposition = {
  image: string,
  title: string,
  subtext: string,
};

type Props = {
  valueProps: Proposition[],
};

export default class ValuePropsRow extends React.Component<Props> {
  renderValueProp(valueProp: Proposition) {
    return (
      <TitleHeader
        image={valueProp.image}
        title={valueProp.title}
        subtext={valueProp.subtext}
        flush
        key={valueProp.title}
        size="small"
        className="ValuePropsRow-item"
      />
    );
  }

  render() {
    return (
      <div className="ValuePropsRow">
        {this.props.valueProps.map(valueProp => this.renderValueProp(valueProp))}
      </div>
    );
  }
}
